import { render, staticRenderFns } from "./business-inactive.component.html?vue&type=template&id=5b07ae99&scoped=true&"
import script from "./business-inactive.component.ts?vue&type=script&lang=ts&"
export * from "./business-inactive.component.ts?vue&type=script&lang=ts&"
import style0 from "./business-inactive.component.scss?vue&type=style&index=0&id=5b07ae99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07ae99",
  null
  
)

export default component.exports